import { useState } from "react"
import rec3 from "../../../assets/images/rec1.png"
import rec2 from "../../../assets/images/rec2.png"
import rec1 from "../../../assets/images/rec3.png"
const CallToActionMobile = () => {
  const [images, setImages] = useState([
    { src: rec3, alt: "Image 1", zIndex: 4 },
    { src: rec2, alt: "Image 3", zIndex: 3 },
    { src: rec1, alt: "Image 2", zIndex: 2 },
  ])

  const handleClick = index => {
    // Move clicked image to the top by setting it as the first element
    const updatedImages = [
      images[index], // Move clicked image to first position
      ...images.filter((_, i) => i !== index), // Keep the rest in order
    ].map((img, i) => ({ ...img, zIndex: images.length - i })) // Reassign z-index

    setImages(updatedImages)
  }

  return (
    <div className="d-flex d-xl-none justify-content-center align-items-center p-5">
      {images.map((img, index) => (
        <img
          key={index}
          src={img.src}
          alt={img.alt}
          style={{
            marginLeft: index !== 0 ? "-80%" : "0%", // Offset others except top image
            zIndex: img.zIndex,
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
          className="img-fluid object-fit-cover"
          onClick={() => handleClick(index)}
        />
      ))}
    </div>
  )
}

export default CallToActionMobile
